module.exports = __webpack_public_path__ + "static/media/gho.b7bb9af2.ogg";